<template>
  <div>
    <div class="upload">
      <div class="upload__btn" @click="openUploadModal">上傳資料</div>
    </div>
    <modal name="upload" :resizable="true" :styles="{ padding: '10px' }">
      <div class="uploader">
        <div class="upload-type-wrapper">
          <input type="radio" value="all" v-model="uploadType" />
          <span>上傳全部</span>
          <input type="radio" value="single" v-model="uploadType" />
          <span>上傳單一語系</span>
          <select
            v-model="selected"
            @change="handleLangChange"
            :disabled="uploadType !== 'single'"
          >
            <option v-for="option in options" :value="option" :key="option">
              {{ option }}
            </option>
          </select>
        </div>
        <div v-if="!!uploadType">
          <input
            type="file"
            class="input"
            accept=".xlsx, .xls"
            multiple
            @change="handleFileFilter"
            ref="inputFile"
            @click="resetFile"
          />
          <button @click="handleClick" :disabled="!isReadyUpload">上傳</button>
        </div>
        <div
          class="notice-wrapper"
          v-if="compareResult && jsonData.length === 0"
        >
          沒有需要變更的內容！
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { validateExcelSheets } from "../../utils/excel-upload-validate";
import { mapGetters } from "vuex";
import {
  validateKeysForProject,
  VALIDATION_TOAST_MS,
} from "@/utils/key-guard";
export default {
  name: "Uploader",
  data() {
    return {
      uploadType: "",
      jsonData: [],
      selected: "",
      options: [],
      devTool: sessionStorage["devTool"] === "true",
      dataInput: null,
      isReadyUpload: false,
      compareResult: false,
      showSelect: false,
      lottery_xlsx: {},
      lotteryList: [
        "game_category_i18n",
        "lottery_i18n",
        "game_description",
        "game_content",
        "game_play",
        "lottery_type_i18n",
      ],
    };
  },

  computed: {
    ...mapGetters([
      "data",
      "isLoading",
      "project",
      "langs",
      "needValidateKey",
      "panelSetting",
    ]),
    xlsxHeader() {
      return ["key", ...this.langs, "ticket"];
    },
  },
  created() {
    this.options = [...this.langs];
    this.selected = this.langs[0];
  },
  methods: {
    resetFile(e) {
      e.target.value = "";
    },
    openUploadModal() {
      this.$modal.show("upload");
      this.$store.dispatch("getProjectSettings");
    },
    handleLangChange() {
      this.$refs.inputFile.value = "";
      this.isReadyUpload = false;
      this.compareResult = false;
    },
    handleFileFilter(e) {
      // if (sessionStorage["devTool"] === "true") {
      //   switch (this.project) {
      //     case "backend-lottery":
      //       this.xlsx_backendLottery(e);
      //       break;
      //   }
      // } else {
      //   this.handleFile(e);
      // }
      this.handleFile(e);
    },
    checkSheetsValid(sheets) {
      this.$store.commit("setIsLoading", true);
      try {
        const inputKeys = validateExcelSheets(
          sheets,
          this.panelSetting.maxBatchUpsertRecords,
        );
        const existsKeyList = this.data.map((item) => item.key);
        const errMsg = this.validateKeyForSpecifyProject(
          this.project,
          inputKeys,
          existsKeyList,
        );
        if (errMsg) {
          this.isReadyUpload = false;
          this.$store.dispatch("handleMessage", {
            success: false,
            text: errMsg,
            durationMs: VALIDATION_TOAST_MS,
          });
          this.$store.commit("setIsLoading", false);
          return null;
        }
        const guardMsg = validateKeysForProject(
          this.project,
          inputKeys,
          existsKeyList,
        );
        if (guardMsg) {
          this.isReadyUpload = false;
          this.$store.dispatch("handleMessage", {
            success: false,
            text: guardMsg,
            durationMs: VALIDATION_TOAST_MS,
          });
          this.$store.commit("setIsLoading", false);
          return null;
        }
        // this.isReadyUpload = true;
        this.$store.dispatch("handleMessage", {
          success: true,
          text: "檢查成功，可以上傳",
        });
        this.$store.commit("setIsLoading", false);
        return true;
      } catch (error) {
        this.isReadyUpload = false;
        const errorText =
          typeof error === "string"
            ? error
            : error && error.message
            ? error.message
            : `類型錯誤：無法讀取未定義的屬性（讀取到'${
                error?.toString?.() || "unknown"
              }'）`;
        this.$store.dispatch("handleMessage", {
          success: false,
          text: errorText,
          durationMs: VALIDATION_TOAST_MS,
        });
        this.$store.commit("setIsLoading", false);
        return null;
      }
    },
    getUploadRows(ws) {
      const rows = this.$xlsx.utils.sheet_to_json(ws);
      // checkSheetsValid validates the trimmed key; send the same value so the row that was
      // checked for duplicates is the row that reaches the server.
      return Object.freeze(
        rows.map((row) =>
          typeof row.key === "string" ? { ...row, key: row.key.trim() } : row,
        ),
      );
    },
    compareAndReplace(wb) {
      const sheetsName = wb.SheetNames[0];
      const ws = wb.Sheets[sheetsName];
      this.jsonData = this.getUploadRows(ws);
      this.compareResult = true;
      this.isReadyUpload = true;
    },
    handleFile(e) {
      const files = e.target.files;
      const f = files[0];
      const reader = new FileReader();

      // filter invalid file extension
      if (!["xlsx", "xls"].includes(f.name.split(".").pop())) {
        this.$store.dispatch("handleMessage", {
          success: false,
          text: "上載格式錯誤，格式應為.xlsx或.xls",
          durationMs: VALIDATION_TOAST_MS,
        });
        return null;
      }

      reader.onload = (e) => {
        this.$store.commit("setIsLoading", true);
        const data = new Uint8Array(e.target.result);

        const workbook = this.$xlsx.read(data, { type: "array" });

        const sheets = Object.values(workbook.Sheets);

        const checkSheetsValid = this.checkSheetsValid(sheets);
        if (checkSheetsValid) {
          this.dataInput = f;
          this.compareAndReplace(workbook);
        } else {
          this.dataInput = null;
        }
      };

      reader.readAsArrayBuffer(f);
    },
    xlsx_backendLottery(e) {
      const files = e.target.files;
      const f = files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = this.$xlsx.read(data, { type: "array" });
        for (const sheet in workbook.Sheets) {
          if (
            Object.prototype.hasOwnProperty.call(workbook.Sheets, sheet) &&
            this.lotteryList.indexOf(sheet) !== -1
          ) {
            this.lottery_xlsx[sheet] = this.$xlsx.utils.sheet_to_json(
              workbook.Sheets[sheet],
            );
          } else {
            console.error(`${sheet} 不在上傳清單內`);
          }
        }
        this.lotteryList = Object.keys(this.lottery_xlsx);
        this.formatLotteryData();
      };
      reader.readAsArrayBuffer(f);
    },
    formatLotteryData() {
      this.$store.commit("setIsLoading", true);
      Object.keys(this.lottery_xlsx).map((sheet) => {
        const data = this.lottery_xlsx[sheet];
        let formateData = {};
        data.map((item) => {
          if (!item["language"]) return;
          const _lang = item["language"]
            .split("-")
            .map((item, index) =>
              index === 1 ? item.toUpperCase() : item.toLowerCase(),
            )
            .join("_");
          Object.keys(item).map((tempData) => {
            if (
              tempData === `${Object.keys(item)[0]}` ||
              tempData === "language" ||
              tempData.match("__EMPTY")
            )
              return;

            const key = `${item[Object.keys(item)[0]]}.${tempData}`;
            formateData[key] = {
              ...formateData[key],
              key: `${sheet}.${Object.keys(item)[0]}.${key}`,
            };
            formateData[key][_lang] = item[tempData];
          });
        });
        const workSheet = this.$xlsx.utils.json_to_sheet(
          Object.values(formateData),
          {
            header: this.xlsxHeader,
          },
        );

        this.$xlsx.writeFile(
          {
            SheetNames: ["mySheet"],
            Sheets: {
              mySheet: workSheet,
            },
          },
          `lottery-${sheet}.xlsx`,
        );
      });

      this.$store.commit("setIsLoading", false);
    },
    isKeyRepeat(key) {
      return this.data.some((obj) => obj.key === key);
    },
    handleClick() {
      this.$store.dispatch("updateMany", {
        data: this.jsonData,
        selectedLang: this.uploadType == "single" ? this.selected : "",
        file: this.dataInput,
      });
      this.$modal.hide("upload");
    },
    // return error message if check failed
    validateKeyForSpecifyProject(projectName, inputKeys, existsKeyListString) {
      if (!this.needValidateKey) {
        return this.validateKey(inputKeys, existsKeyListString);
      }
      return this.validateKeyPunctuationAndCaseSensitive(
        inputKeys,
        existsKeyListString,
      );
    },
    removePunctuationAndCaseSensitive(input) {
      return input.replace(/[^a-zA-Z0123456789]/g, "").toLowerCase();
    },
    getKeyMapRemovedPunctuation(keys) {
      const keyMap = {};
      keys.forEach((key) => {
        const newKey = this.removePunctuationAndCaseSensitive(key);
        keyMap[newKey] = key;
      });
      return keyMap;
    },
    // validate new key for any project, only check "/n" in key
    validateKey(inputKeys, existsKeyList) {
      // exists key no need to check
      const notExistsKeyList = inputKeys.filter(
        (key) => !existsKeyList.includes(key),
      );
      if (notExistsKeyList.length == 0) {
        return;
      }

      // check "/n" in new key
      const checkFailedKeyList = notExistsKeyList.filter((key) =>
        key.includes("\n"),
      );
      if (checkFailedKeyList.length > 0) {
        return `請求的key: [${checkFailedKeyList.join(",")}]包含換行符號`;
      }
    },
    validateKeyPunctuationAndCaseSensitive(inputKeys, existsKeyList) {
      const keysNeedCheck = inputKeys;
      if (keysNeedCheck.length == 0) {
        return;
      }
      const duplicateInputKeys = this.findDuplicateItem(inputKeys);
      if (duplicateInputKeys.length > 0) {
        return `請求的key: [${duplicateInputKeys.join(",")}]有重複`;
      }
      const allExistsRemovedPunctuationKeyMap =
        this.getKeyMapRemovedPunctuation(existsKeyList);
      for (const inputKey of keysNeedCheck) {
        const keyRemovedPunctuation =
          this.removePunctuationAndCaseSensitive(inputKey);
        // MPS開頭的i18n key要不檢查 <-- 盤口的key特別處理
        // 如果removedPunctuationKey存在且不是MPS開頭的key且請求的key不存在於資料庫中，則視為重複
        if (
          allExistsRemovedPunctuationKeyMap[keyRemovedPunctuation] &&
          !keyRemovedPunctuation.startsWith("mps") &&
          !existsKeyList.includes(inputKey)
        ) {
          return `重複KEY值: '${inputKey}', 因無視標點符號處理, 無視大小階, 視為已存在該項目中的 '${allExistsRemovedPunctuationKeyMap[keyRemovedPunctuation]}'`;
        }
        if (!existsKeyList.includes(inputKey) && inputKey.includes("\n")) {
          return `請求的key: [${inputKey}]包含換行符號`;
        }
      }
      const duplicateKeys = this.findDuplicateItem(
        keysNeedCheck
          .filter(
            (key) => !existsKeyList.includes(key) && !key.startsWith("MPS"),
          )
          .map((key) => this.removePunctuationAndCaseSensitive(key)),
      );
      if (duplicateKeys.length > 0) {
        const allInputKeyMap = this.getKeyMapRemovedPunctuation(keysNeedCheck);
        return `請求的新key: [${duplicateKeys
          .map((key) => allInputKeyMap[key])
          .join(",")}]有重複`;
      }
    },
    findDuplicateItem(arr) {
      return arr.filter((item, index) => arr.indexOf(item) !== index);
    },
  },
  watch: {
    $route() {
      if (this.$refs.inputFile) {
        this.$refs.inputFile.value = "";
      }
      this.dataInput = null;
      this.isReadyUpload = false;
    },
    uploadType() {
      this.dataInput = null;
      this.isReadyUpload = false;
      this.compareResult = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.upload {
  display: flex;
  margin: 0.75rem 0;
  @media screen and (min-width: 768px) {
    margin: 1rem 0;
  }
  .upload__btn {
    background-color: #21ba45;
    color: #fff;
    box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
    padding: 0.5rem 1.5rem;
    border-radius: 0.3rem;
    cursor: pointer;
    &:hover {
      background-color: #16ab39;
    }
  }
}
.uploader {
  margin: 0.75rem 0;
  @media screen and (min-width: 768px) {
    margin: 1rem 0;
  }
  .upload-type-wrapper {
    margin: 20px 10px;
    input[type="radio"] {
      margin: 0 10px;
    }
    select {
      margin: 0 10px;
    }
  }
  .notice-wrapper {
    margin: 20px 15px;
    font-size: 20px;
    color: red;
  }
  .input[type="file"] {
    margin: 0px 20px;
    // @media screen and (min-width: 768px) {
    //   margin: 0;
    // }
  }
}
</style>
